// router/index.ts
import { createRouter, createWebHistory } from "vue-router";
import { checkAdminGroup, useAdminCheck } from "@/composables/adminGroupGuard";

const { isUserInAdminGroup } = useAdminCheck();

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("../views/DashboardView.vue"),
    },
    {
      path: "/document-view/:id",
      name: "document-view",
      component: () => import("../views/DocumentView.vue"),
    },
    {
      path: "/all-documents-view",
      name: "all-documents-view",
      component: () => import("../views/AllDocumentsView.vue"),
    },
    {
      path: "/upload-document-view",
      name: "upload-document-view",
      component: () => import("../views/UploadDocumentView.vue"),
      beforeEnter: async (to, from, next) => {
        await checkAdminGroup();
        if (isUserInAdminGroup.value) {
          next();
        } else {
          next({ name: "home" });
        }
      },
    },
    {
      path: "/settings-view",
      name: "settings-view",
      component: () => import("../views/SettingsView.vue"),
      beforeEnter: async (to, from, next) => {
        await checkAdminGroup();
        if (isUserInAdminGroup.value) {
          next();
        } else {
          next({ name: "home" });
        }
      },
    },
    {
      path: "/prompts",
      name: "prompts-view",
      component: () => import("../views/PromptsView.vue"),
      beforeEnter: async (to, from, next) => {
        await checkAdminGroup();
        if (isUserInAdminGroup.value) {
          next();
        } else {
          next({ name: "home" });
        }
      },
    },
  ],
});

export default router;
